



















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('cases');

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    computed: {
        disciplines() {
            return module.getters('getDisciplines');
        }
    },

    methods: {
        changeFilter: function(e) {
            const value = e.currentTarget.value;
            this.$emit('filter', value);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Bullets extends Vue {}

